import { CARRIER_SERVICES_ACTIONS } from './carrierServices.types'

/**
 * @param {import('./carrierServices.types').CarrierService[]} payload
 * @returns {Object}
 */
export const setCarrierServicesAction = payload => ({
  type: CARRIER_SERVICES_ACTIONS.SET_CARRIER_SERVICES,
  payload
})

/**
 * @param {import('./carrierServices.types').CarrierService} payload
 * @returns {Object}
 */
export const setCarrierServiceAction = payload => ({
  type: CARRIER_SERVICES_ACTIONS.SET_CARRIER_SERVICE,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setCarrierServicesStatusAction = payload => ({
  type: CARRIER_SERVICES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setCarrierServicesErrorsAction = payload => ({
  type: CARRIER_SERVICES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearCarrierServicesErrorsAction = () => ({
  type: CARRIER_SERVICES_ACTIONS.CLEAR_ERRORS
})

/**
 * @returns {Object}
 */
export const clearCarrierServicesAction = () => ({
  type: CARRIER_SERVICES_ACTIONS.CLEAR_CARRIER_SERVICES
})
